import colorPattern from '../../../DesignSystem/colors'

const lightIconColors = {
    'icon-primary': colorPattern.onyx,
    'icon-secondary': colorPattern.keshi,
    'icon-invert': colorPattern.pearl,
    'icon-brand-primary': colorPattern.sky,
    'icon-brand-secondary': colorPattern.violet,
    'icon-league-qualifier': colorPattern.yellow,
} as const

export default lightIconColors
